import type { CSearchTranslations } from "./pl";

const GROUP_LABELS: Record<string, string> = {
  c_news: "Aktuelles",
  c_blog: "Blog",
  c_shop: "Shop",
  c_faq: "FAQ",
  c_events_calendar: "Veranstaltungen",
  c_photo_gallery: "Fotogalerien",
  c_video_gallery_outer: "Videogalerien",
  c_files_to_download: "Downloads",
  c_job_offers: "Stellenangebote",
  c_advertisements: "Kleinanzeigen",
  c_descriptive_page: "Seiten",
  c_procedures: "Verfahren",
  c_polls: "Umfragen",
  c_browser_press_online: "Online-Presse",
  c_shop_delivery_points: "Abholpunkte",
};

export const de: CSearchTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  inputLabel: "Suchen",
  inputPlaceholder: "Sagen Sie uns, wonach Sie suchen",
  submit: "Suchen",
  resultsFor: "Ergebnisse für",
  noQuery: "Geben Sie einen Suchbegriff ein.",
  noResults: "Keine Ergebnisse für den eingegebenen Begriff.",
  wrongWords: "Zu kurze Wörter übersprungen (min. 3 Zeichen):",
  catalogsTitle: "Seiten",
  resultsCount: (n) => `(gefunden: ${n})`,
  groupLabel: (symbol) => GROUP_LABELS[symbol] ?? symbol,
};
